import Image from 'next/image'
import React, { FC } from 'react'

import { Box, Divider } from '@material-ui/core'

import Flexbox from '~/components/shared/Flexbox'
import Text from '~/components/shared/Text'

import { sellingEasyConfig } from '~/data/mocks/sellYourVesselConfigs'

import { IS_BOAT, getEntityByBrand } from '~/brands'

import { useSellingEasySectionStyles } from './sellingEasySection.styles'

import bgImageBoat from '~/../public/static/images/sell-vessel.boat.png'
import bgImageRv from '~/../public/static/images/sell-vessel.rv.png'

const bgImage = getEntityByBrand<string>({ rv: bgImageRv, boat: bgImageBoat })

const SellingEasySection: FC = () => {
  const s = useSellingEasySectionStyles()

  return (
    <Box mt={4}>
      <Text
        textAlign="center"
        fontFamily="Prompt, sans-serif"
        fontSize={{ xs: 24, md: 35 }}
        fontWeight={600}
      >
        {IS_BOAT ? (
          <>
            Selling on Trade
            <Box component="span" color="primary.main">
              a
            </Box>
            Boat is Easy
          </>
        ) : (
          <Text
            textAlign="center"
            fontFamily="Prompt, sans-serif"
            fontSize={{ xs: 24, md: 35 }}
            fontWeight={600}
          >
            Selling on TradeRV’s is Easy
          </Text>
        )}
      </Text>

      <Text
        textAlign="center"
        mt={1}
        fontSize={{ xs: 16, md: 18 }}
        m="0 auto"
        px={{ xs: 1.5, md: 0 }}
        className={s.descriptionText}
      >
        We help you every step of the way with pre-filled specifications for{' '}
        popular make and models and tools to make selling online easy.
      </Text>

      <Flexbox
        justifyContent="center"
        flexDirection={{ xs: 'column', md: 'row' }}
        alignItems="center"
      >
        <Box mr={4}>
          {sellingEasyConfig().map((item, index) => {
            const isNoLastStep = index !== 7
            const countNumber = index + 1

            return (
              <Flexbox alignItems="center" key={item.text}>
                <Flexbox
                  flexDirection="column"
                  position="relative"
                  ml={{ xs: 2.5, md: 0 }}
                >
                  <Box
                    mt={2}
                    mr={{ xs: 1, md: 2 }}
                    className={s.stepIcon}
                    style={{ backgroundColor: item.color }}
                  >
                    <Text className={s.counter}>{countNumber}</Text>
                  </Box>

                  {isNoLastStep && (
                    <Divider
                      orientation="vertical"
                      className={s.dashedLine}
                      style={{
                        height: item.height
                      }}
                    />
                  )}
                </Flexbox>

                <Box
                  width={{ xs: 310, md: 508 }}
                  mt={2.5}
                  bgcolor="bg.default"
                  borderRadius="4px"
                  py={1.5}
                >
                  <Text mx={2}>{item.text}</Text>

                  {item.helperText && (
                    <Text mx={2} pt={0.5} fontSize={14} color="textSecondary">
                      {item.helperText}
                    </Text>
                  )}
                </Box>
              </Flexbox>
            )
          })}
        </Box>

        <Box mt={5}>
          <Image
            src={bgImage}
            layout="fixed"
            width={333}
            height={731}
            objectFit="cover"
            objectPosition="center"
          />
        </Box>
      </Flexbox>
    </Box>
  )
}

export default SellingEasySection
